module.exports = __webpack_public_path__ + "static/img/card2.e080dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card2.png
// module id = Ygzu
// module chunks = 0